export enum AcceptOption {
  CARD = 'card',
  SSN = 'ssn',
}
